import { Box } from '@amzn/awsui-components-react-v3';

export const STATUS_LOADING = 'loading';
export const STATUS_ERROR = 'error';
export const STATUS_FINISHED = 'finished';

export const SPOTCP_HCP_COMPONENT_OPTIONS = [
  { label: 'Product Cost', id: 'product_cost' },
  { label: 'Associate Fees', id: 'associate_fees' },
  { label: 'Bad Debt', id: 'bad_debt' },
  { label: 'Free Replacement Cost', id: 'free_replacement_cost' },
  { label: 'Giftwrap Cost', id: 'giftwrap_cost' },
  { label: 'Inbound Freight', id: 'inbound_freight' },
  { label: 'Liquidation Cost', id: 'liquidation_cost' },
  { label: 'Other Cost', id: 'other_cost' },
  { label: 'Payment Fees', id: 'payment_fees' },
  { label: 'Refunds Revenue', id: 'refunds_revenue' },
  { label: 'Sales Discounts', id: 'sales_discounts' },
  { label: 'Shipping Cost', id: 'shipping_cost' },
  { label: 'Sponsored Link Dees', id: 'sponsored_link_fees' },
  { label: 'Variable Cs Cost', id: 'variable_cs_cost' },
  { label: 'Variable Fc Cost', id: 'variable_fc_cost' },
  { label: 'Vendor Returns', id: 'vendor_returns' },
  { label: 'Closing Fees', id: 'closing_fees' },
  { label: 'Discretionary Coop', id: 'discretionary_coop' },
  { label: 'Fulfillment Fees', id: 'fulfillment_fees' },
  { label: 'Giftwrap Revenue', id: 'giftwrap_revenue' },
  { label: 'Liquidation Revenue', id: 'liquidation_revenue' },
  { label: 'Other Revenue', id: 'other_revenue' },
  { label: 'Quick Pay Discounts', id: 'quick_pay_discounts' },
  { label: 'Refunds Cost', id: 'refunds_cost' },
  { label: 'Shipping Revenue', id: 'shipping_revenue' },
  { label: 'Subscription Revenue', id: 'subscription_revenue' },
  { label: 'Vendor Allowances', id: 'vendor_allowances' },
  { label: 'Display Ads', id: 'display_ads' },
  { label: 'Seller Credits', id: 'seller_credits' },
];

export const PAGE_SIZE_OPTIONS = [
  { value: 15, label: '15 Components' },
  { value: 25, label: '25 Components' },
  { value: 35, label: '35 Components' },
];

/**
 * Summary table column definition
 */
export const summaryColumnDefinitions = [
  {
    id: 'component',
    header: 'Component',
    minWidth: 200,
    sortingField: 'component_fa',
    cell: (item) => {
      const fontWeight = item.component_fa === 'Total' ? 'bold' : 'normal';
      return (
        <Box textAlign="left" fontWeight={fontWeight}>
          {item.component_fa}
        </Box>
      );
    },
  },
  {
    id: 'spotcp',
    header: 'Spot CP / Unit Value',
    minWidth: 200,
    sortingField: 'spot_fa',
    cell: (item) => <Box textAlign="right">{Math.round(item.spot_fa * 10000) / 10000 || '-'}</Box>,
  },
  {
    id: 'hcp_fa',
    header: 'HCP / Unit Value (FA)',
    minWidth: 200,
    sortingField: 'hcp_fa',
    cell: (item) => <Box textAlign="right">{Math.round(item.hcp_fa * 10000) / 10000 || '-'}</Box>,
  },
  {
    id: 'netcp_fa',
    header: 'Net Variance / Unit Value (FA)',
    minWidth: 260,
    sortingField: 'diff_fa',
    cell: (item) => {
      let value = Math.round(item.diff_fa * 10000) / 10000;
      let colorText = value >= 0 ? 'inherit' : 'text-status-error';
      return (
        <Box textAlign="right" color={colorText}>
          {value || '-'}
        </Box>
      );
    },
  },
  {
    id: 'pgms_fa',
    header: 'Net Variance as % of PGMS (FA)',
    minWidth: 260,
    sortingField: 'pGMS_fa',
    cell: (item) => <Box textAlign="right">{Math.round(item.pGMS_fa * 10000) / 100 || '-'}</Box>,
  },
  {
    id: 'accuracy_fa',
    header: 'Accuracy % (FA)',
    minWidth: 180,
    sortingField: 'accuracy_fa',
    cell: (item) => <Box textAlign="right">{Math.round(item.accuracy_fa * 100) / 100 || '-'}</Box>,
  },
  {
    id: 'weight_fa',
    header: 'Weight % (FA)',
    minWidth: 180,
    sortingField: 'weight_fa',
    cell: (item) => <Box textAlign="right">{Math.round(item.weight_fa * 10000) / 100 || '-'}</Box>,
  },
  {
    id: 'hcp_la',
    header: 'HCP / Unit Value (LA)',
    minWidth: 200,
    sortingField: 'hcp_la',
    cell: (item) => <Box textAlign="right">{Math.round(item.hcp_la * 10000) / 10000 || '-'}</Box>,
  },
  {
    id: 'netcp_la',
    header: 'Net Variance / Unit Value (LA)',
    minWidth: 260,
    sortingField: 'diff_la',
    cell: (item) => {
      let value = Math.round(item.diff_la * 10000) / 10000;
      let colorText = value >= 0 ? 'inherit' : 'text-status-error';
      return (
        <Box textAlign="right" color={colorText}>
          {value || '-'}
        </Box>
      );
    },
  },
  {
    id: 'pgms_la',
    header: 'Net Variance as % of PGMS (LA)',
    minWidth: 260,
    sortingField: 'pGMS_la',
    cell: (item) => <Box textAlign="right">{Math.round(item.pGMS_la * 10000) / 100 || '-'}</Box>,
  },
  {
    id: 'accuracy_la',
    header: 'Accuracy % (LA)',
    minWidth: 180,
    sortingField: 'accuracy_la',
    cell: (item) => <Box textAlign="right">{Math.round(item.accuracy_la * 100) / 100 || '-'}</Box>,
  },
  {
    id: 'weight_la',
    header: 'Weight % (LA)',
    minWidth: 180,
    sortingField: 'weight_la',
    cell: (item) => <Box textAlign="right">{Math.round(item.weight_la * 10000) / 100 || '-'}</Box>,
  },
];

export const VISIBLE_CONTENT_OPTIONS = [
  {
    label: 'Main instance properties',
    options: summaryColumnDefinitions.map((col) => ({
      id: col.id,
      label: col.header,
    })),
  },
];



// WEBPACK FOOTER //
// ./src/components/spotcp/elements.jsx